import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DID_YOU_MOVE: "Har du flyttet?",
      YOU_HAVE_TO: "Da er du nødt til å",
      ADD_NEW_ADDRESS: "legg til en ny adresse.",
      ADDRESS_INFORMATION: "Adresseopplysninger",
      ADDRESS: "Adresse",
      POSTAL_CODE: "Postnummer",
      CITY: "By",
      INSTRUCTIONS_TO_DRIVER: "Melding til sjåfør?",
      DOOR_CODE: "Portkode",
      ADDRESS_NAME: "Navn på adresse",
      LENGTH_OF_POSTAL_CODE: 4,
      MUST_BE_EXACTLY_DIGITS: (digit: number) => `Må være ${digit} sifre`,
      CAN_ONLY_CONTAIN_NUMBERS: "Kan bare inneholde tall",
      WE_CANNOT_DELIVER_HERE: "Beklager, vi kan ikke levere til din adresse",
      OPTIONAL_HELPER_TEXT: "Frivillig",
      SAVE_BUTTON_TEXT: "Lagre endring",
      CANCEL_BUTTON_TEXT: "Avbryt",
      MANDATORY_FIELD: "Obligatorisk felt",
      DELIVERY: "Levering",
      WHEN_TO_DELIVER: "Når skal vi levere",
      HOW_OFTEN_TO_DELIVER: "Hvor ofte skal vi levere",
      LOADING_IN_PLACEHOLDER: "Laster inn...",
      CHECKING_IF_WE_CAN_DELIVER_HERE: "Sjekker om vi kan levere hit...",
      DELIVERY_DETAILS: "Leveringsinformasjon",
      USE_AS_ACTIVE_ADDRESS_LABEL: "Bruk som aktiv leveringsadresse",
      ACTIVE_ADDRESS: "Aktiv adresse",
    },
    se: {
      DID_YOU_MOVE: "Har du flyttat?",
      YOU_HAVE_TO: "Då behöver du",
      ADD_NEW_ADDRESS: "lägga till en ny adress.",
      ADDRESS_INFORMATION: "Adressuppgifter",
      ADDRESS: "Adress",
      POSTAL_CODE: "Postnummer",
      CITY: "Ort",
      INSTRUCTIONS_TO_DRIVER: "Instruktioner till chauffören",
      DOOR_CODE: "Portkod",
      ADDRESS_NAME: "Namn på adress",
      LENGTH_OF_POSTAL_CODE: 5,
      MUST_BE_EXACTLY_DIGITS: (digit: number) =>
        `Måste vara exakt ${digit} siffror`,
      CAN_ONLY_CONTAIN_NUMBERS: "Kan bara innehålla siffror",
      WE_CANNOT_DELIVER_HERE: "Tyvärr, vi kan inte leverera här",
      OPTIONAL_HELPER_TEXT: "Frivilligt",
      SAVE_BUTTON_TEXT: "Spara ändring",
      CANCEL_BUTTON_TEXT: "Avbryt",
      MANDATORY_FIELD: "Obligatoriskt fält",
      DELIVERY: "Leverans",
      WHEN_TO_DELIVER: "När ska vi leverera",
      HOW_OFTEN_TO_DELIVER: "Hur ofta ska vi leverera",
      LOADING_IN_PLACEHOLDER: "Laster inn...",
      DELIVERY_DETAILS: "Leveransdetaljer",
      USE_AS_ACTIVE_ADDRESS_LABEL: "Använd som aktiv leveransadress.",
      ACTIVE_ADDRESS: "Aktiv adress",
    },
    dk: {
      DID_YOU_MOVE: "Er du flyttet?",
      YOU_HAVE_TO: "Så er du nødt til at",
      ADD_NEW_ADDRESS: "tilføj en ny adresse.",

      ADDRESS_INFORMATION: "Adresseoplysninger",
      ADDRESS: "Adresse",
      POSTAL_CODE: "Postnummer",
      CITY: "By",
      INSTRUCTIONS_TO_DRIVER: "Instruktioner til chaufføren",
      DOOR_CODE: "Dørkode",
      ADDRESS_NAME: "Navn på adresse",
      LENGTH_OF_POSTAL_CODE: 4,
      MUST_BE_EXACTLY_DIGITS: (digit: number) =>
        `Skal være nøjagtigt ${digit} cifre`,
      CAN_ONLY_CONTAIN_NUMBERS: "Kan kun indeholde tal",
      WE_CANNOT_DELIVER_HERE: "Beklager, vi kan ikke levere her",
      OPTIONAL_HELPER_TEXT: "Frivilligt",
      SAVE_BUTTON_TEXT: "Gem ændring",
      CANCEL_BUTTON_TEXT: "Annuller",
      MANDATORY_FIELD: "Obligatorisk felt",
      DELIVERY: "Levering",
      WHEN_TO_DELIVER: "Hvornår leverer vi",
      HOW_OFTEN_TO_DELIVER: "Hvor ofte leverer vi",
      LOADING_IN_PLACEHOLDER: "Laster inn...",
      DELIVERY_DETAILS: "Leveringsinformation",
      USE_AS_ACTIVE_ADDRESS_LABEL: "Brug som aktiv leveringsadresse",
      ACTIVE_ADDRESS: "Aktiv adresse",
    },
  } as const
)[language];
